(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $bc44b5da379ac29b$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL('4ko55'), JSON.parse("[\"4ko55\",\"index.3046ac8b.js\",\"hOerA\",\"icons.c5b0f01c.svg\"]"));

// it is a common practice to use all uppercase for config constants
const $a536fbf06af412b5$export$923ea8233b386e99 = 'https://forkify-api.jonas.io/api/v2/recipes/';
const $a536fbf06af412b5$export$196440f71ed9f601 = 10;
const $a536fbf06af412b5$export$5feaddb1377b7f5e = 10;
const $a536fbf06af412b5$export$7167c830cefcb6b5 = '4fef75f3-d6ef-4e22-8933-15cb70849404';
const $a536fbf06af412b5$export$3ce8858248d89a69 = 2.5;




const $77eae7726dbdfc03$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const $77eae7726dbdfc03$export$2b3ff41fecbef7c8 = async function(url, uploadData) {
    try {
        // we use race of the url fetch with the timeout promise because people could have a bad connection
        // and the fetch could take forever. To avoid that we race it with the timeout promise
        const fetchPro = uploadData ? fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(uploadData)
        }) : fetch(url);
        const res = await Promise.race([
            fetchPro,
            $77eae7726dbdfc03$var$timeout((0, $a536fbf06af412b5$export$196440f71ed9f601))
        ]);
        const data = await res.json();
        if (!res.ok) throw new Error(`${data.message} (${res.status})`);
        return data;
    } catch (err) {
        // we can't just alert the error because getJSON is an async function, so it returns a promise
        // and the promise will be resolved, not rejected, so in model.js we won't be able to catch error
        // alert(err);
        // to fix that we need to re-throw the error, so the promise is returned as rejected
        throw err;
    }
}; /*
export const getJSON = async function (url) {
  try {
    // we use race of the url fetch with the timeout promise because people could have a bad connection
    // and the fetch could take forever. To avoid that we race it with the timeout promise

    const res = await Promise.race([fetch(url), timeout(TIMEOUT_SEC)]);
    const data = await res.json();

    if (!res.ok) throw new Error(`${data.message} (${res.status})`);

    return data;
  } catch (err) {
    // we can't just alert the error because getJSON is an async function, so it returns a promise
    // and the promise will be resolved, not rejected, so in model.js we won't be able to catch error
    // alert(err);
    // to fix that we need to re-throw the error, so the promise is returned as rejected
    throw err;
  }
};

export const sendJSON = async function (url, uploadData) {
  try {
    const fetchPro = fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(uploadData),
    });

    const res = await Promise.race([fetchPro, timeout(TIMEOUT_SEC)]);
    const data = await res.json();

    if (!res.ok) throw new Error(`${data.message} (${res.status})`);
    return data;
  } catch (err) {
    // we can't just alert the error because getJSON is an async function, so it returns a promise
    // and the promise will be resolved, not rejected, so in model.js we won't be able to catch error
    // alert(err);
    // to fix that we need to re-throw the error, so the promise is returned as rejected
    throw err;
  }
};
*/ 


const $0bc36518f6cf0450$export$ca000e230c0caa3e = {
    recipe: {},
    search: {
        query: '',
        results: [],
        page: 1,
        resultsPerPage: (0, $a536fbf06af412b5$export$5feaddb1377b7f5e)
    },
    bookmarks: []
};
const $0bc36518f6cf0450$var$createRecipeObject = function(data) {
    // as a value to our own created state object with recipe object inside (as there can be many other data stuff in our state base)
    // destructure data.data into recipe object so we can assign its properties
    const { recipe: recipe } = data.data;
    return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        ...recipe.key && {
            key: recipe.key
        }
    };
};
const $0bc36518f6cf0450$export$b96725c7a035d60b = async function(id) {
    try {
        // fetch the url + put it into JSON
        const data = await (0, $77eae7726dbdfc03$export$2b3ff41fecbef7c8)(`${(0, $a536fbf06af412b5$export$923ea8233b386e99)}${id}?key=${(0, $a536fbf06af412b5$export$7167c830cefcb6b5)}`);
        $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe = $0bc36518f6cf0450$var$createRecipeObject(data);
        if ($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks.some((bookmark)=>bookmark.id === id)) $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.bookmarked = true;
        else $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.bookmarked = false;
    // console.log(state.recipe);
    } catch (err) {
        console.log(err);
        throw err;
    }
};
const $0bc36518f6cf0450$export$202b8e5cb363a0c4 = async function(query) {
    try {
        // store the query in our state search object.
        $0bc36518f6cf0450$export$ca000e230c0caa3e.search.query = query;
        // get the query data
        const data = await (0, $77eae7726dbdfc03$export$2b3ff41fecbef7c8)(`${(0, $a536fbf06af412b5$export$923ea8233b386e99)}?search=${query}&key=${(0, $a536fbf06af412b5$export$7167c830cefcb6b5)}`);
        // store the query results in our state's search object.
        $0bc36518f6cf0450$export$ca000e230c0caa3e.search.results = data.data.recipes.map((rec)=>{
            return {
                id: rec.id,
                title: rec.title,
                publisher: rec.publisher,
                image: rec.image_url,
                ...rec.key && {
                    key: rec.key
                }
            };
        });
        $0bc36518f6cf0450$export$ca000e230c0caa3e.search.page = 1;
    } catch (err) {
        console.log(err);
        throw err;
    }
};
const $0bc36518f6cf0450$export$8d7f79465139ab72 = function(page = $0bc36518f6cf0450$export$ca000e230c0caa3e.search.page) {
    $0bc36518f6cf0450$export$ca000e230c0caa3e.search.page = page;
    const start = (page - 1) * $0bc36518f6cf0450$export$ca000e230c0caa3e.search.resultsPerPage;
    const end = page * $0bc36518f6cf0450$export$ca000e230c0caa3e.search.resultsPerPage;
    return $0bc36518f6cf0450$export$ca000e230c0caa3e.search.results.slice(start, end);
};
const $0bc36518f6cf0450$export$5e23f4642ecad5ea = function(newServings) {
    $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.ingredients.forEach((ing)=>{
        ing.quantity = ing.quantity * newServings / $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.servings;
    });
    $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.servings = newServings;
};
// add bookmark information to the local storage
const $0bc36518f6cf0450$var$persistBookmarks = function() {
    localStorage.setItem('bookmarks', JSON.stringify($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks));
};
const $0bc36518f6cf0450$export$72009cc673d27d80 = function(recipe) {
    // Add bookmark
    $0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks.push(recipe);
    // Mark current recipe as bookmarked
    if (recipe.id === $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.id) $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.bookmarked = true;
    $0bc36518f6cf0450$var$persistBookmarks();
};
const $0bc36518f6cf0450$export$136048bcb9946c75 = function(id) {
    // find the index of the element in an array based on its id.
    const index = $0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks.findIndex((el)=>el.id === id);
    // deleting the id based on its index and splice method
    $0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks.splice(index, 1);
    // set the bookmarked value to false
    if (id === $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.id) $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.bookmarked = false;
    $0bc36518f6cf0450$var$persistBookmarks();
};
const $0bc36518f6cf0450$var$init = function() {
    const storage = localStorage.getItem('bookmarks');
    if (storage) $0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks = JSON.parse(storage);
};
$0bc36518f6cf0450$var$init();
const $0bc36518f6cf0450$export$d660c2254e74960d = async function(newRecipe) {
    try {
        const ingredients = Object.entries(newRecipe).filter((entry)=>entry[0].startsWith('ingredient') && entry[1] !== '').map((ing)=>{
            // const ingArr = ing[1].replaceAll(' ', '').split(',');
            const ingArr = ing[1].split(',').map((el)=>el.trim());
            if (ingArr.length !== 3) throw new Error('Wrong ingredient format! Please use the right one :)');
            const [quantity, unit, description] = ingArr;
            return {
                quantity: quantity ? +quantity : null,
                unit: unit,
                description: description
            };
        });
        const recipe = {
            title: newRecipe.title,
            source_url: newRecipe.sourceUrl,
            image_url: newRecipe.image,
            publisher: newRecipe.publisher,
            cooking_time: +newRecipe.cookingTime,
            servings: +newRecipe.servings,
            ingredients: ingredients
        };
        const data = await (0, $77eae7726dbdfc03$export$2b3ff41fecbef7c8)(`${(0, $a536fbf06af412b5$export$923ea8233b386e99)}?key=${(0, $a536fbf06af412b5$export$7167c830cefcb6b5)}`, recipe);
        $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe = $0bc36518f6cf0450$var$createRecipeObject(data);
        $0bc36518f6cf0450$export$72009cc673d27d80($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        throw err;
    }
};



var $a922e5462747601b$exports = {};

$a922e5462747601b$exports = (parcelRequire("aNJCr")).getBundleURL('4ko55') + "icons.c5b0f01c.svg";


class $c732e9e6223e19d8$export$2e2bcd8739ae039 {
    _data;
    /**
   * Render the received object to the DOM
   * @param {Object | Object[]} data The data to be rendered (e.g recipe)
   * @param {boolean} [render=true] If false, creates a markup string instead of rendering to the DOM
   * @returns {undefined | string} A markup string is returned if render=false
   * @this {Object} View instance
   * @todo Finish implementation
   */ render(data, render = true) {
        // the array.isarray(data) checks whether data is an array or not (we could've passed object so we have to check)
        // if (!data || (Array.isArray(data) && data.length === 0))
        //   return this.renderError();
        this._data = data;
        // create an HTML markup of our info from model.js from state to show to user
        const markup = this._generateMarkup();
        if (!render) return markup;
        // clear up spinner that is in our html element
        this._clear();
        // show it to them!
        this._parentElement.insertAdjacentHTML('afterbegin', markup);
    }
    update(data) {
        // the array.isarray(data) checks whether data is an array or not (we could've passed object so we have to check)
        // if (!data || (Array.isArray(data) && data.length === 0))
        //   return this.renderError();
        this._data = data;
        // Here we will create a new Markup, but not render it! (We wont add it to parent element HTML).
        const newMarkup = this._generateMarkup();
        // we will compare the new markup with the old and only render changed attributes between the two.
        // but comparing strings is hard, and newmarkup is a string atm. So we first will convert it to a dom object.
        // this dom is stored in our memory, not shown on the page
        const newDom = document.createRange().createContextualFragment(newMarkup);
        // selecting all the elements of newDom
        const newElements = Array.from(newDom.querySelectorAll('*'));
        const curElements = Array.from(this._parentElement.querySelectorAll('*'));
        // loop over both arrays and compare the two.
        newElements.forEach((newEl, i)=>{
            const curEl = curElements[i];
            // isEqualNode is a handy method to compare the two.
            //   console.log(newEl.isEqualNode(curEl));
            //if new element is different from cur element change curent's text content
            // updates changed TEXT
            if (!newEl.isEqualNode(curEl) && newEl.firstChild?.nodeValue.trim() !== '') curEl.textContent = newEl.textContent;
            //updates changed ATTRIBUTES (like data-update-to so we can further increase or decrease portions as we use those data attributes to know on which portion we are atm)
            //if new element doesn't equal current element
            if (!newEl.isEqualNode(curEl)) // take the object with the new attributes of an element and convert it to an array
            // then loop over that array and set the attributes name and value onto the current element
            Array.from(newEl.attributes).forEach((attr)=>curEl.setAttribute(attr.name, attr.value));
        });
    }
    _clear() {
        this._parentElement.innerHTML = '';
    }
    renderSpinner() {
        // clear the HTML markup that was there before (most likely some other recipe)
        this._clear();
        // create a markup for our spinner
        const markup = `
      <div class="spinner">
          <svg>
              <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports)))}#icon-loader"></use>
          </svg>
      </div>
      `;
        // show our spinner!
        this._parentElement.insertAdjacentHTML('afterbegin', markup);
    }
    renderError(message = this._errorMessage) {
        this._clear();
        const markup = `
        <div class="error">
            <div>
                <svg>
                <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports)))}#icon-alert-triangle"></use>
                </svg>
            </div>

            <p>${message}</p>
        </div>`;
        this._parentElement.insertAdjacentHTML('afterbegin', markup);
    }
    renderMessage(message = this._message) {
        this._clear();
        const markup = `
        <div class="message">
            <div>
                <svg>
                <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports)))}#icon-smile"></use>
                </svg>
            </div>

            <p>${message}</p>
        </div>`;
        this._parentElement.insertAdjacentHTML('afterbegin', markup);
    }
}



var $b0f2bd7507f92d39$exports = {};
// FRACTY CONVERTS DECIMAL NUMBERS TO FRACTIONS BY ASSUMING THAT TRAILING PATTERNS FROM 10^-2 CONTINUE TO REPEAT
// The assumption is based on the most standard numbering conventions
// e.g. 3.51 will convert to 3 51/100 while 3.511 will convert to 3 23/45
// Throw any number up to 16 digits long at fracty and let fracy do the work.
// If number is beyond 16 digits fracty will truncate at 15 digits to compensate for roundoff errors created in IEEE 754 Floating Point conversion.
$b0f2bd7507f92d39$exports = function(number) {
    let type;
    if (number < 0) {
        number = Math.abs(number);
        type = '-';
    } else type = '';
    if (number === undefined) return `Your input was undefined.`;
    if (isNaN(number)) return `"${number}" is not a number.`;
    if (number == 9999999999999999) return `${type}9999999999999999`;
    if (number > 9999999999999999) return `Too many digits in your integer to maintain IEEE 754 Floating Point conversion accuracy.`;
    if (Number.isInteger(number)) return `${type}${number}`;
    if (number < .000001) return '0';
    const numberString = number.toString();
    const entry = numberString.split('.');
    let integer = entry[0];
    let decimal;
    if (decimal == '0' && integer !== '0') return integer;
    else if (decimal == '0' && integer == '0') return '0';
    else if (numberString.length >= 17) decimal = entry[1].slice(0, entry[1].length - 1);
    else decimal = entry[1];
    if (decimal == '99' && integer !== '0') return `${integer} 99/100`;
    else if (decimal == '99' && integer == '0') return `99/100`;
    else if (1 - parseFloat(`.${decimal}`) < .0011) decimal = '999';
    if (decimal == undefined) return integer;
    const decimalRev = decimal.split('').reverse().join(''); //Reverse the string to look for patterns.
    const patternSearch = /^(\d+)\1{1,2}/; //This greedy regex matches the biggest pattern that starts at the beginning of the string (at the end, in the case of the reversed string). A lazy regex doesn't work because it only identifies subpatterns in cases where subpatterns exist (e.g. '88' in '388388388388'), thus pattern capture must be greedy.
    let pattern = decimalRev.match(patternSearch); //If there's a pattern, it's full sequence is in [0] of this array and the single unit is in [1] but it may still need to be reduced further.
    if (pattern && decimal.length > 2) {
        let patternSequence = pattern[0].split('').reverse().join('');
        let endPattern = pattern[1].split('').reverse().join('');
        if (endPattern.length > 1) {
            let endPatternArray = endPattern.split('');
            let testSingleUnit = 1;
            for(let i = 0; i < endPatternArray.length; i++)testSingleUnit /= endPatternArray[0] / endPatternArray[i];
            if (testSingleUnit === 1) endPattern = endPatternArray[0];
        }
        if (endPattern.length > 1 && endPattern.length % 2 === 0) endPattern = parseInt(endPattern.slice(0, endPattern.length / 2), 10) - parseInt(endPattern.slice(endPattern.length / 2, endPattern.length), 10) === 0 ? endPattern.slice(0, endPattern.length / 2) : endPattern;
        return $b0f2bd7507f92d39$var$yesRepeat(decimal, endPattern, patternSequence, integer, type); //Begin calculating the numerator and denominator for decimals that have a pattern.
    } else return $b0f2bd7507f92d39$var$noRepeat(decimal, integer, type); //Begin calculating the numerator and denominator for decimals that don't have a pattern.
};
//IF THERE'S A TRAILING PATTERN FRACTY DIVIDES THE INPUT BY ONE SUBTRACTED FROM THE NEAREST BASE 10 NUMBER WITH NUMBER OF ZEROS EQUAL TO THE LENGTH OF THE REPEATED PATTERN (I.E. A SERIES OF 9'S) MULTIPLIED BY THE BASE 10 NUMBER GREATER THAN AND CLOSEST TO THE INPUT.
function $b0f2bd7507f92d39$var$yesRepeat(decimal, endPattern, patternSequence, integer, type) {
    const rep = true; //The numerator repeats.
    const nonPatternLength = decimal.length - patternSequence.length >= 1 ? decimal.length - patternSequence.length : 1; //Does the length of the non pattern segment of the input = 0? If it does, that's incorrect since we know it must equal at least 1, otherwise it's the length of the decimal input minus the length of the full pattern.
    const decimalMultiplier2 = Math.pow(10, nonPatternLength); //Second multiplier to use.
    const float = parseFloat(`0.${decimal}`); //Convert the decimal input to a floating point number.
    const decimalMultiplier1 = Math.pow(10, endPattern.length); //Find the right multiplier to use for both numerator and denominator, which will later have 1 subtracted from it in the case of the denominator.
    const numerator = Math.round((float * decimalMultiplier1 - float) * Math.pow(10, nonPatternLength)); //Find the numerator to be used in calculating the fraction that contains a repeating trailing sequence.
    const denominator = (decimalMultiplier1 - 1) * decimalMultiplier2; //Caluculate the denominator using the equation for repeating trailing sequences.
    return $b0f2bd7507f92d39$var$reduce(numerator, denominator, integer, type, rep); //Further reduce the numerator and denominator.
}
//IF THERE'S NO TRAILING PATTERN FRACTY DIVIDES THE INPUT BY THE NEAREST BASE 10 INTEGER GREATER THAN THE NUMERATOR.
function $b0f2bd7507f92d39$var$noRepeat(decimal, integer, type) {
    const rep = false; //The numerator doesn't repeat.
    const numerator = parseInt(decimal, 10); //Numerator begins as decimal input converted into an integer.
    const denominator = Math.pow(10, decimal.length); //Denominator begins as 10 to the power of the length of the numerator.
    return $b0f2bd7507f92d39$var$reduce(numerator, denominator, integer, type, rep); //Reduce the numerator and denominator.
}
//FRACTY REDUCES THE FRACTION.
function $b0f2bd7507f92d39$var$reduce(numerator, denominator, integer, type, rep) {
    const primeNumberArray = [
        2,
        3,
        5
    ]; //If the numerator isn't from a repeating decimal case, the initialized array of prime numbers will suffice to find the common denominators.
    if (rep === true) {
        for(let i = 3; i * i <= numerator; i += 2)if (numerator % i === 0) primeNumberArray.push(i);
    }
    let j = 0; //Initialize counter over the prime number array for the while loop.
    let comDenom = 1; //Initialize the common denominator.
    let num = numerator; //Initialize the numerator.
    let den = denominator; //Initialize the denominator.
    while(j <= primeNumberArray.length)if (num % primeNumberArray[j] === 0 && den % primeNumberArray[j] === 0) {
        comDenom = comDenom * primeNumberArray[j];
        num = num / primeNumberArray[j];
        den = den / primeNumberArray[j];
    } else j++;
    return $b0f2bd7507f92d39$var$returnStrings(den, num, integer, type);
}
//FRACTY RETURNS THE REDUCED FRACTION AS A STRING.
function $b0f2bd7507f92d39$var$returnStrings(den, num, integer, type) {
    if (den === 1 && num === 1) {
        integer = `${type}${(parseInt(integer) + 1).toString()}`; //Add 1 to the integer and return a string without a fraction.
        return `${integer}`;
    } else if (num === 0) return `${type}${integer}`;
    else if (integer == '0') return `${type}${num}/${den}`;
    else return `${type}${integer} ${num}/${den}`; //If there's an integer and a fraction return both.
}


class $95a7d6c4a0a50ae1$var$RecipeView extends (0, $c732e9e6223e19d8$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector('.recipe');
    _errorMessage = 'We could not find that recipe. Please try another one!';
    _message = '';
    // publisher and we pass through controller function as an argument which is a subscriber
    addHandlerRender(handler) {
        // 5. Call control recipes whenever there's a hashchange or we just load without any hash page.
        [
            'hashchange',
            'load'
        ].forEach((ev)=>window.addEventListener(ev, handler));
    // window.addEventListener('hashchange', controlRecipes);
    // window.addEventListener('load', controlRecipes);
    }
    addHandlerUpdateServings(handler) {
        this._parentElement.addEventListener('click', function(e) {
            const btn = e.target.closest('.btn--update-servings');
            if (!btn) return;
            console.log(btn);
            const updateTo = +btn.dataset.updateTo;
            if (updateTo > 0) handler(updateTo);
        });
    }
    // What
    addHandlerAddBookmark(handler) {
        this._parentElement.addEventListener('click', function(e) {
            const btn = e.target.closest('.btn--bookmark');
            if (!btn) return;
            handler();
        });
    }
    _generateMarkup() {
        // Create HTML with variables.
        // For ingredients loop over the ingredient array and add HTML element for each.
        return `
        <figure class="recipe__fig">
          <img src="${this._data.image}" alt="${this._data.title}" class="recipe__img" />
          <h1 class="recipe__title">
            <span>${this._data.title}</span>
          </h1>
        </figure>

        <div class="recipe__details">

          <div class="recipe__info">
            <svg class="recipe__info-icon">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-clock"></use>
            </svg>
            <span class="recipe__info-data recipe__info-data--minutes">${this._data.cookingTime}</span>
            <span class="recipe__info-text">minutes</span>
          </div>

          <div class="recipe__info">
            <svg class="recipe__info-icon">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-users"></use>
            </svg>
            <span class="recipe__info-data recipe__info-data--people">${this._data.servings}</span>
            <span class="recipe__info-text">servings</span>

            <div class="recipe__info-buttons">
              <button class="btn--tiny btn--update-servings" data-update-to="${this._data.servings - 1}">
                <svg>
                  <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-minus-circle"></use>
                </svg>
              </button>
              <button class="btn--tiny btn--update-servings" data-update-to="${this._data.servings + 1}">
                <svg>
                  <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-plus-circle"></use>
                </svg>
              </button>
            </div>

          </div>

          <div class="recipe__user-generated ${this._data.key ? '' : 'hidden'}">
            <svg>
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-user"></use>
            </svg>
          </div>

          <button class="btn--round btn--bookmark">
            <svg class="">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-bookmark${this._data.bookmarked ? '-fill' : ''}"></use>
            </svg>
          </button>

        </div>

        <div class="recipe__ingredients">

          <h2 class="heading--2">Recipe ingredients</h2>

          <ul class="recipe__ingredient-list">

          ${this._data.ingredients.map(this._generateMarkupIngredient).join('')}
          </ul>

        </div>

        <div class="recipe__directions">

          <h2 class="heading--2">How to cook it</h2>
          
          <p class="recipe__directions-text">
            This recipe was carefully designed and tested by
            <span class="recipe__publisher">${this._data.publisher}</span>. Please check out
            directions at their website.
          </p>

          <a
            class="btn--small recipe__btn"
            href=${this._data.sourceUrl}
            target="_blank"
          >
            <span>Directions</span>
            <svg class="search__icon">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-arrow-right"></use>
            </svg>
          </a>

        </div>
    `;
    }
    _generateMarkupIngredient(ing) {
        return `
    <li class="recipe__ingredient">
        <svg class="recipe__icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-check"></use>
        </svg>
        <div class="recipe__quantity">${ing.quantity ? (0, (/*@__PURE__*/$parcel$interopDefault($b0f2bd7507f92d39$exports)))(ing.quantity).toString() : ''}</div>
        <div class="recipe__description">
        <span class="recipe__unit">${ing.unit}</span>
        ${ing.description}
        </div>
    </li>
    `;
    }
}
var $95a7d6c4a0a50ae1$export$2e2bcd8739ae039 = new $95a7d6c4a0a50ae1$var$RecipeView();


class $8d9571d82bdb9304$var$SearchView {
    #parentEl = document.querySelector('.search');
    getQuery() {
        const query = this.#parentEl.querySelector('.search__field').value;
        this.#clearInput();
        return query;
    }
    #clearInput() {
        this.#parentEl.querySelector('.search__field').value = '';
    }
    addHandlerSearch(handler) {
        this.#parentEl.addEventListener('submit', function(e) {
            e.preventDefault();
            handler();
        });
    }
}
var $8d9571d82bdb9304$export$2e2bcd8739ae039 = new $8d9571d82bdb9304$var$SearchView();





class $d511a9d636491df2$var$PreviewView extends (0, $c732e9e6223e19d8$export$2e2bcd8739ae039) {
    _parentElement = '';
    _generateMarkup() {
        const id = window.location.hash.slice(1);
        return `
    <li class="preview">
        <a class="preview__link ${this._data.id === id ? 'preview__link--active' : ''}" href="#${this._data.id}">
        
            <figure class="preview__fig">
                <img src="${this._data.image}" alt="${this._data.title}" />
            </figure>

            <div class="preview__data">
                <h4 class="preview__title">${this._data.title}</h4>

                <p class="preview__publisher">${this._data.publisher}</p>
                
                <div class="preview__user-generated ${this._data.key ? '' : 'hidden'}">
                    <svg>
                        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-user"></use>
                    </svg>
                </div>

            </div>
        </a>
    </li>
    `;
    }
}
var $d511a9d636491df2$export$2e2bcd8739ae039 = new $d511a9d636491df2$var$PreviewView();



class $99e6646170dcffc3$var$ResultsView extends (0, $c732e9e6223e19d8$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector('.results');
    _errorMessage = 'No recipes found for your query! Try another ;)';
    _message = '';
    _generateMarkup() {
        return this._data.map((result)=>(0, $d511a9d636491df2$export$2e2bcd8739ae039).render(result, false)).join('');
    }
}
var $99e6646170dcffc3$export$2e2bcd8739ae039 = new $99e6646170dcffc3$var$ResultsView();





class $0884acaefafcc64c$var$BookmarksView extends (0, $c732e9e6223e19d8$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector('.bookmarks__list');
    _errorMessage = 'No bookmarks yet!';
    _message = '';
    addHandlerRender(handler) {
        window.addEventListener('load', handler);
    }
    _generateMarkup() {
        return this._data.map((bookmark)=>(0, $d511a9d636491df2$export$2e2bcd8739ae039).render(bookmark, false)).join('');
    }
}
var $0884acaefafcc64c$export$2e2bcd8739ae039 = new $0884acaefafcc64c$var$BookmarksView();




class $f03ebf78cca01ded$var$PaginationView extends (0, $c732e9e6223e19d8$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector('.pagination');
    addHandlerClick(handler) {
        this._parentElement.addEventListener('click', function(e) {
            const btn = e.target.closest('.btn--inline');
            if (!btn) return;
            const goToPage = +btn.dataset.goto;
            handler(goToPage);
        });
    }
    _generateMarkup() {
        const curPage = this._data.page;
        const numPages = Math.ceil(this._data.results.length / this._data.resultsPerPage);
        // Page 1 and there are other pages
        if (curPage === 1 && numPages > 1) return this._generateMarkupButton(1);
        // Last page
        if (curPage === numPages && numPages > 1) return this._generateMarkupButton(-1);
        // Other page
        if (curPage < numPages) return this._generateMarkupButton(1) + this._generateMarkupButton(-1);
        // Page 1 and there are NO other pages
        return '';
    }
    _generateMarkupButton(value) {
        if (value === 1) return `
        <button data-goto="${this._data.page + value}" class="btn--inline pagination__btn--next">
            <span>Page ${this._data.page + value}</span>
            <svg class="search__icon">
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-arrow-right"></use>
            </svg>
        </button>`;
        if (value === -1) return `
        <button data-goto="${this._data.page + value}" class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-arrow-left"></use>
            </svg>
            <span>Page ${this._data.page + value}</span>
        </button>`;
    }
}
var $f03ebf78cca01ded$export$2e2bcd8739ae039 = new $f03ebf78cca01ded$var$PaginationView();




class $da53bbe9f60c4332$var$AddRecipeView extends (0, $c732e9e6223e19d8$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector('.upload');
    _message = 'Recipe was successfully uploaded :)';
    _window = document.querySelector('.add-recipe-window');
    _overlay = document.querySelector('.overlay');
    _btnOpen = document.querySelector('.nav__btn--add-recipe');
    _btnClose = document.querySelector('.btn--close-modal');
    constructor(){
        super();
        this._addHandlerShowWindow();
        this._addHandlerHideWindow();
    }
    toggleWindow() {
        this._overlay.classList.toggle('hidden');
        this._window.classList.toggle('hidden');
    }
    _addHandlerShowWindow() {
        this._btnOpen.addEventListener('click', this.toggleWindow.bind(this));
    }
    _addHandlerHideWindow() {
        this._btnClose.addEventListener('click', this.toggleWindow.bind(this));
        this._overlay.addEventListener('click', this.toggleWindow.bind(this));
    }
    addHandlerUpload(handler) {
        this._parentElement.addEventListener('submit', function(e) {
            e.preventDefault();
            const dataArr = [
                ...new FormData(this)
            ];
            const data = Object.fromEntries(dataArr);
            handler(data);
        });
    }
    _generateMarkup() {}
}
var $da53bbe9f60c4332$export$2e2bcd8739ae039 = new $da53bbe9f60c4332$var$AddRecipeView();


// NEW API URL (instead of the one shown in the video)
// https://forkify-api.jonas.io
// if (module.hot) {
//   module.hot.accept();
// }
const $cdc8bba1cf7e6fe0$var$controlRecipes = async function() {
    try {
        // 1. Take the hash of the link, and if there isn't one exit the function as there's nothing to do.
        const id = window.location.hash.slice(1);
        if (!id) return;
        // 1.5) Update results view to mark the selected search result + bookmarks
        (0, $99e6646170dcffc3$export$2e2bcd8739ae039).update($0bc36518f6cf0450$export$8d7f79465139ab72());
        (0, $0884acaefafcc64c$export$2e2bcd8739ae039).update($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks);
        // 2. load the recipe and while waiting render the spinner for some nice UI.
        (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).renderSpinner();
        await $0bc36518f6cf0450$export$b96725c7a035d60b(id);
        // 3. once recipe loaded from 3rd party API render the received information on a page!
        (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        console.error(err);
        (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).renderError();
    }
};
//4. Call the control recipes!
$cdc8bba1cf7e6fe0$var$controlRecipes();
// Search functionality
const $cdc8bba1cf7e6fe0$var$controlSearchResults = async function() {
    try {
        // Get search query, return if there isn't one
        const query = (0, $8d9571d82bdb9304$export$2e2bcd8739ae039).getQuery();
        if (!query) return;
        (0, $99e6646170dcffc3$export$2e2bcd8739ae039).renderSpinner();
        // Wait for search results to load
        await $0bc36518f6cf0450$export$202b8e5cb363a0c4(query);
        // Render the search results
        (0, $99e6646170dcffc3$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$8d7f79465139ab72());
        // Render the initial pagination buttons
        (0, $f03ebf78cca01ded$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.search);
    } catch (err) {
        console.log(err);
    }
};
$cdc8bba1cf7e6fe0$var$controlSearchResults();
// Pagination functionality
const $cdc8bba1cf7e6fe0$var$controlPagination = function(goToPage) {
    // Render NEW results
    (0, $99e6646170dcffc3$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$8d7f79465139ab72(goToPage));
    // Render NEW pagination buttons
    (0, $f03ebf78cca01ded$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.search);
};
// Servings functionality
const $cdc8bba1cf7e6fe0$var$controlServings = function(newServings) {
    // Update the recipe servings in state
    $0bc36518f6cf0450$export$5e23f4642ecad5ea(newServings);
    // Update the recipe view
    //   recipeView.render(model.state.recipe);
    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).update($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
};
// Bookmarks functionality
const $cdc8bba1cf7e6fe0$var$controlAddBookmark = function() {
    //1. add/remove bookmark
    if (!$0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.bookmarked) $0bc36518f6cf0450$export$72009cc673d27d80($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
    else $0bc36518f6cf0450$export$136048bcb9946c75($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.id);
    // 2. update the recipe view
    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).update($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
    // 3. render bookmarks
    (0, $0884acaefafcc64c$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks);
};
const $cdc8bba1cf7e6fe0$var$controlBookmarks = function() {
    (0, $0884acaefafcc64c$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks);
};
const $cdc8bba1cf7e6fe0$var$controlAddRecipe = async function(newRecipe) {
    try {
        // show the loading spinner
        (0, $da53bbe9f60c4332$export$2e2bcd8739ae039).renderSpinner();
        // upload the new recipe data...
        await $0bc36518f6cf0450$export$d660c2254e74960d(newRecipe);
        console.log($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
        // Render recipe
        (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
        // display success message
        (0, $da53bbe9f60c4332$export$2e2bcd8739ae039).renderMessage();
        // Render the bookmark view
        (0, $0884acaefafcc64c$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks);
        // Change ID in URL
        window.history.pushState(null, '', `#${$0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.id}`);
        //Close form window
        setTimeout(function() {
            (0, $da53bbe9f60c4332$export$2e2bcd8739ae039).toggleWindow();
        }, (0, $a536fbf06af412b5$export$3ce8858248d89a69) * 1000);
    } catch (err) {
        console.error(err);
        (0, $da53bbe9f60c4332$export$2e2bcd8739ae039).renderError(err.message);
    }
};
const $cdc8bba1cf7e6fe0$var$init = function() {
    (0, $0884acaefafcc64c$export$2e2bcd8739ae039).addHandlerRender($cdc8bba1cf7e6fe0$var$controlBookmarks);
    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).addHandlerRender($cdc8bba1cf7e6fe0$var$controlRecipes);
    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).addHandlerUpdateServings($cdc8bba1cf7e6fe0$var$controlServings);
    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).addHandlerAddBookmark($cdc8bba1cf7e6fe0$var$controlAddBookmark);
    (0, $8d9571d82bdb9304$export$2e2bcd8739ae039).addHandlerSearch($cdc8bba1cf7e6fe0$var$controlSearchResults);
    (0, $f03ebf78cca01ded$export$2e2bcd8739ae039).addHandlerClick($cdc8bba1cf7e6fe0$var$controlPagination);
    (0, $da53bbe9f60c4332$export$2e2bcd8739ae039).addHandlerUpload($cdc8bba1cf7e6fe0$var$controlAddRecipe);
};
$cdc8bba1cf7e6fe0$var$init();

})();
//# sourceMappingURL=index.3046ac8b.js.map
